export const hostUrl = typeof window !== 'undefined' ? window?.location.hostname : '';

export const domainFromUrl = (url = hostUrl): string => {
  const domainSplit = url.split('.');
  return domainSplit[domainSplit.length - 1];
};
